import { useGroupSlug } from "@/hooks/use-group-slug";
import { useKitUuid } from "@/hooks/use-kit-uuid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBug } from "@nnr/fontawesome-sharp-light/icons/sharp/light";
import { Link } from "@tanstack/react-router";
import { RoleGate } from "../gate/RoleGate";
import { Button } from "../ui/button";

export const KitDebugPageLink: React.FC = () => {
  const groupSlug = useGroupSlug();
  const kitUuid = useKitUuid();

  return (
    <RoleGate systemRoles={["super"]}>
      <Link
        to="/w/$groupSlug/k/$kitUuid/debug"
        params={{ groupSlug, kitUuid: kitUuid! }}
      >
        <Button variant="outline">
          <FontAwesomeIcon icon={faBug} />
          Debug Rag
        </Button>
      </Link>
    </RoleGate>
  );
};
